import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function LatestUpdates() {
  const latest = comics.slice(0, 10);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14" aria-label="最新更新">
      <SectionHeading
        title="最新更新"
        subtitle="每日 150+ 话准时上新，追更从未如此丝滑"
        moreTo="/category"
        moreLabel="全部更新"
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5 md:gap-5">
        {latest.map((comic, index) => (
          <ComicCard key={comic.id} comic={comic} index={index} />
        ))}
      </div>
    </section>
  );
}